import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

interface Props {
    id: string
    value: string[]
    options: { value: string; label: string }[]
    onChange: (value: string[]) => void
}

export default function MultiSelectInput({ id, value, options, onChange }: Props) {
    const toggle = (v: string, checked: boolean) =>
        onChange(checked ? [...value, v] : value.filter((x) => x !== v))

    return (
        <div className="grid gap-2 sm:grid-cols-2">
            {options.map((o) => {
                const cid = `${id}_${o.value}`
                return (
                    <Label
                        key={o.value}
                        htmlFor={cid}
                        className="flex cursor-pointer items-center gap-2.5 rounded-md border bg-card px-3 py-2 text-sm font-normal transition-colors hover:bg-muted has-[[data-state=checked]]:border-primary has-[[data-state=checked]]:bg-primary/5"
                    >
                        <Checkbox
                            id={cid}
                            checked={value.includes(o.value)}
                            onCheckedChange={(c) => toggle(o.value, c === true)}
                        />
                        {o.label}
                    </Label>
                )
            })}
        </div>
    )
}
